import { Indexable } from '../core/models/indexable';

export type PaymentType = 'billet' | 'deposit' | 'PIX';

export const PAYMENT_TYPES: Indexable<PaymentType, string> = {
  billet: 'Boleto',
  deposit: 'Depósito em Conta',
  PIX: 'PIX'
};

export class FinancialOptions {
  paymentTypes: PaymentType[];
  installment: boolean;

  constructor(o?: FinancialOptions) {
    if (!o) {
      o = {} as any;
    }

    if (!o.paymentTypes) {
      o.paymentTypes = ['billet'];
    }

    if (!o.installment) {
      o.installment = false;
    }
    if(!o.paymentTypes.includes('PIX')){
      o.paymentTypes.push('PIX');
    }
    Object.assign(this, o);
  }
}
